import { styled } from "@mui/material";
import MuiTableCell from "@mui/material/TableCell";

export const DesktopOnlyTableCell = styled(MuiTableCell)(({ theme }) => ({
  color: theme.palette.shades.neutral[800],
  minWidth: "fit-content",
  whiteSpace: "nowrap",
  [theme.breakpoints.down("mobile")]: {
    display: "none",
  },
}));
